import {useState} from "react";
import {IoMdClose} from 'react-icons/io';
import style from "./style.module.scss"

export default function PopupForm() {
    const [show, setShow] = useState(true);//!sessionStorage.getItem("hidePopupForm"));

    function hidePopup() {
        setShow(false);
        sessionStorage.setItem('hidePopupForm', 'true');
    }

    return show ? <div className={style.root}>
        <div className={style.container}>
            <IoMdClose className={style.close} size="25" onClick={hidePopup} />
            {/* <div className={style.close}><G</div> */}
            <div className={style.formCnt}>
                <div className={style.title}>WE LIGGEN NIET TE ZONNEBADEN!</div>
                <p className={style.txt1}>Integendeel! We werken hard om alle 3000+ eigendommen op de vastgoedmonitor te zetten. De Costa del Sol eigendommen zijn wel bijna compleet. Neem gerust al een kijkje en aarzel niet ons te contacteren voor meer info of om een afspraak in te plannen.</p>
                {/* <div className={style.inputCnt}>
                    <input type="text" placeholder="Enter your email" />
                    <div className={style.button}>
                        <FiMail size="20" color="white" />
                    </div>
                </div> */}
                <p className={style.title}>Wij kijken uit naar uw reactie. HASTA LUEGO, TOT BINNENKORT</p>
            </div>
            <div className={style.picture} style={{backgroundImage: 'url("/media/images/popupform/picture.jpg")'}}>
            </div>
        </div>
    </div> : <div />
}